import { HiAcademicCap } from "react-icons/hi2";

export const CertificationsIcon = ({ width, height, color, ...props }) => (
  <HiAcademicCap
    size={width || height || 15}
    color={color || "currentColor"}
    {...props}
  />
);
